'use strict';

var $errorMessage = $('#errormessage').val();
var toastMessageHelper = require('../../utils/toastMessageHelper');
var validateUtils = require('../../utils/dataAndSlots');

$('body').on('click', '#ckc-jewelry-appointment-date, .date-picker-icon', function (e) {
    e.preventDefault();
    var $dateInput = $('#ckc-jewelry-appointment-date');
    if (!$dateInput.data('datepicker')) {
        validateUtils.initializeEarPiercingDatepicker();
    }
    $dateInput.datepicker('show');
});

// Initialize datepicker on page load
$(document).ready(function () {
    validateUtils.initializeEarPiercingDatepicker();
    // Load time slots if store is already selected (coming back from form page)
    var selectedStore = $('#astral-formdata-details .storedata .store-container.checked input[type="radio"]').val();
    if (selectedStore) {
        validateUtils.loadSlots(selectedStore);
    }
});

/**
 * Resets the time slot selection to its default state.
 * Updates the text of the selected time slot element to show the alternative text
 * (either from data-alttext attribute or defaults to 'Choose...').
 *
 * @function resetTimeSlot
 * @returns {void}
 */
function resetTimeSlot() {
    var $sel = $('.astral-selected-value');
    var altText = $sel.attr('data-alttext') || $sel.data('alttext') || 'Choose...';
    $sel.text(altText);
}

$('body').on('change', '#showroom-page input[name="storeOption"]', function () {
    var storeId = $(this).val();
    validateUtils.loadSlots(storeId);
    resetTimeSlot();

    var $dateInput = $('#ckc-jewelry-appointment-date');
    if ($dateInput.length && $dateInput.data('datepicker')) {
        $dateInput.datepicker('setDate', null);
        $dateInput.val('');
        validateUtils.initializeEarPiercingDatepicker();
    }

    var $tasSelectedValue = $('.astral-selected-value');
    if ($tasSelectedValue.length) {
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '');
        $('.astral-selected-value').removeClass('timeslot-selected-value');
    }
});

$('body').on('click', '#astraltimeslots', function () {
    var $this = $(this);
    if ($this.data('requesting') === true) {
        return;
    }
    var selectedDate = $('#ckc-jewelry-appointment-date').val();
    if (!selectedDate) {
        return;
    }
    var storeID = $('#showroom-page .storedata .store-container.checked input[type="radio"]').val();
    var url = $(this).data('url');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var selectedslot = $('.astral-selected-value').attr('data-slot');
    var tryatshowroomData = {
        storeID: storeID,
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot
    };
    $this.data('requesting', true);
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#astraltimeslotplaced').html('');
            if (data.success === false) {
                $('.noslots-available').removeClass('d-none');
                $('.pickup-slots, .pickup-slot-scroll.scroll-bar').addClass('d-none');
                $.spinner().stop();
                $this.data('requesting', false);
                return;
            }
            $('.pickup-slot-scroll.scroll-bar').removeClass('d-none');
            $('#astraltimeslotplaced').html(data);
            $('.pickup-slot-scroll').scrollTop(0);
            $.spinner().stop();
            $this.data('requesting', false);
        },
        error: function () {
            $.spinner().stop();
            $this.data('requesting', false);
        }
    });
});

$('body').on('click', '#astraltimeslotplaced .time-slot-value', function () {
    if ($(this).hasClass('strick-out')) return;

    var selectedSlot = $(this).data('id');
    $('#selectedPickupSlot').val(selectedSlot);

    $('.astral-selected-value').attr('data-slot', selectedSlot);
});

/**
 * Handle piercing type dropdown selection
 */
$('body').on('click', '.salutation-dropdown .custom-option-value', function () {
    var $this = $(this);
    var selectedValue = $this.data('code') || $this.text().trim();
    var $dropdown = $this.closest('.custom-drop-down-section');
    $dropdown.find('.piercing-selected-value').text($this.text()).removeClass('appointment-dropdown-placeholder');
    $('#purposeOfValuation').val(selectedValue);
    $dropdown.find('.custom-option-value').removeClass('selected');
    $this.addClass('selected');
    $dropdown.find('.custom-option-values').removeClass('show');
    $('.purpose-of-valuation-dropdown').removeClass('is-invalid');
    $('.purpose-of-valuation-dropdown').siblings('.invalid-feedback').text('').hide();
});

$('body').on('click', '#showroom-page .storedata .store-container', function () {
    $('#showroom-page .storedata .store-container').removeClass('checked');
    $(this).addClass('checked');
});

$('body').on('click', '#showroom-page .time-slot-session .time-slot-value', function () {
    var $this = $(this);
    var $selected = $this.closest('.time-slot-select').find('.custom-drop-down-section .selected-value');
    if ($selected.length) {
        $selected.addClass('timeslot-selected-value');
        $('.time-slot-select .slot-dropdown-section').removeClass('is-invalid');
    }
});

/**
 * Fetches and updates available jewelry appointment time slots based on selected date and store.
 *
 * Collects selected store ID, customer details, selected date, and previously selected slot,
 * then makes an AJAX POST request to retrieve updated time slot HTML.
 * On success, it replaces the existing time slot container content.
 *
 * @function updateJewelrySlots
 * @returns {void}
 */
function updateJewelrySlots() {
    var selectedDate = $('#ckc-jewelry-appointment-date').val();
    var storeID = $('#showroom-page .storedata .store-container.checked input[type="radio"]').val();
    var url = $('#astraltimeslots').data('url');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var selectedslot = $('.astral-selected-value').attr('data-slot');
    var tryatshowroomData = {
        storeID: storeID,
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot || ''
    };

    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#astraltimeslotplaced').html('');
            if (data.success === false) {
                return;
            }
            $('#astraltimeslotplaced').html(data);
        }
    });
}

$('body').on('change', '#ckc-jewelry-appointment-date', function () {
    $('.select-date-picker').addClass('d-none');
    $('.date-picker-input').removeClass('is-invalid');
    $('.invalid-feedback .noslots-available').addClass('d-none');
    var $tasSelectedValue = $('.astral-selected-value');
    if ($tasSelectedValue.length) {
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '');
        $tasSelectedValue.removeClass('timeslot-selected-value');
        $('.session-time-slots .time-slot-value').removeClass('time-slot-value-highlight');
        $tasSelectedValue.attr('data-slot', '');
    }

    updateJewelrySlots();
});

$('body').on('click', '#Showroom-btn', function (e) {
    e.preventDefault();
    var storeID = $('#showroom-page .storedata .store-container.checked input[type="radio"]').val();
    var $selectedLabel = $('label[for="storedata-' + storeID + '"]');
    var storeName = $selectedLabel.find('.store-name').text().trim();
    var selectedDate = $('#ckc-jewelry-appointment-date').val();
    var selectedSlot = $('.astral-selected-value').text().trim().toLowerCase();
    var url = $(this).data('url');
    $('#SelectedDate').val(selectedDate);
    $('#SelectedTimer').val(selectedSlot);
    $('#showrromid').val(storeID);
    $('#ShowroomName').val(storeName);
    var isValid = true;

    if (selectedDate === '') {
        $('.select-date-picker').removeClass('d-none');
        isValid = false;
    }

    if (selectedSlot === 'select your slot') {
        $('.pickup-slots').removeClass('d-none');
        $('.noslots-available').addClass('d-none');
        isValid = false;
    }

    var $datePickerWrapper = $('.date-picker-input');
    var $slotdiv = $('#slot-dropdown-section');
    var $dateError = $('.select-date-picker');
    var $slotError = $('.pickup-slots');
    if (!$slotError.hasClass('d-none')) {
        $slotdiv.addClass('is-invalid');
    } else {
        $slotdiv.removeClass('is-invalid');
    }

    if (!$dateError.hasClass('d-none')) {
        $datePickerWrapper.addClass('is-invalid');
    } else {
        $datePickerWrapper.removeClass('is-invalid');
    }

    if (!isValid) {
        return;
    }
    var showroomData = {
        storeID: storeID,
        selectedDate: selectedDate,
        selectedSlot: selectedSlot
    };
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        data: showroomData,
        success: function (data) {
            if (data) {
                $('#showroom-page').addClass('d-none');
                $('#customer-formdata').removeClass('d-none');
                $('#customer-formdata').html(data);
                $.spinner().stop();
                $('html, body').animate({
                    scrollTop: $('#customer-formdata').offset().top
                }, 500);
                $('#customer-formdata').scrollTop(0);
            }
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification($errorMessage);
        }
    });
});

$(document).on('click', '.language-preference-dropdown .custom-option-value', function () {
    var selectedLanguage = $(this).data('title');
    var $languagePreference = $('#languagepreference');
    var $languageDropdown = $('.language-preference-dropdown');

    $languagePreference.val(selectedLanguage);
    $languagePreference.siblings('.invalid-feedback').text('');
    $languageDropdown.find('.custom-drop-down').removeClass('is-invalid');
    $languageDropdown.find('.selected-value').removeClass('placeholder-text');
});

/**
 * Handle click event on SubmitDatabtn to validate and submit form data via AJAX
 */
$('body').on('click', '#SubmitDatabtn', function (e) {
    e.preventDefault();

    var isFormValid = true;
    var $form = $('#jewelry-formdata');
    $form.find('input').each(function () {
        if (!validateUtils.validateField($(this))) {
            isFormValid = false;
        }
    });
    var whatsappOption = $form.find('#whatsappoption').is(':checked');
    var textmessage = $form.find('#textoption').is(':checked');
    var emailOption = $form.find('label[for="emailoption"]').hasClass('checked');

    var $firstnameInput = $('#firstName');
    if ($firstnameInput.hasClass('is-invalid')) {
        $('.firstname-input-field .custom-drop-down').addClass('error-valid');
    }

    var $phoneInput = $('#phone');
    if ($phoneInput.hasClass('is-invalid')) {
        $('.phone-input-field .custom-drop-down').addClass('error-valid');
    }

    if ($('.selected-value.piercing-selected-value').hasClass('appointment-dropdown-placeholder')) {
        var $errorMsg = $('#purposeOfValuation').data('missing-error');
        $('.purpose-of-valuation-dropdown').addClass('is-invalid');
        $('.purpose-of-valuation-dropdown').siblings('.invalid-feedback').text($errorMsg).show();
        isFormValid = false;
    }

    if (!isFormValid) {
        return;
    }

    var submitUrl = $form.data('submiturl');
    var formData = {
        salutation: $('#catalogueTitle').val(),
        firstName: $firstnameInput.val().trim(),
        lastName: $('#lastName').val().trim(),
        email: $('#email').val().trim(),
        phone: $phoneInput.val().trim(),
        countryCode: $('.phone-input-field .country-code .custom-option-value').data('id'),
        optionalattribute: $('#purposeOfValuation, #optionalattribute').val(),
        appointmentSlot: $('#SelectedTimer').val(),
        appointmentDate: $('#SelectedDate').val(),
        appointmentstoreID: $('#showrromid').val(),
        ShowroomName: $('#ShowroomName').val().trim(),
        languagepreference: $('#languagepreference').val(),
        whatsappOption: whatsappOption,
        textmessage: textmessage,
        emailOption: emailOption,
        termsAndConditionsAccepted: $('#termsAccepted').is(':checked')
    };
    $.spinner().start();
    $.ajax({
        url: submitUrl,
        type: 'POST',
        data: formData,
        success: function (response) {
            if (response) {
                $.ajax({
                    url: response.redirectUrl,
                    type: 'GET',
                    data: {
                        appointmentData: response.appointmentData
                    },
                    success: function (dataresponse) {
                        $('#customer-formdata').addClass('d-none');
                        $('#customerDetails-page').removeClass('d-none');
                        $('#customerDetails-page').html(dataresponse);
                        $.spinner().stop();
                        $('html, body').animate({
                            scrollTop: $('#customerDetails-page').offset().top
                        }, 500);
                    }
                });
            }
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification($errorMessage);
        }
    });
});

$('body').on('click', '#backto-formPage', function (e) {
    e.preventDefault();
    $('#customerDetails-page').addClass('d-none');
    $('#customer-formdata').removeClass('d-none');
    $('html, body').animate({
        scrollTop: $('#customer-formdata').offset().top
    }, 500);
});

$('body').on('click', '#backto-showroomPage', function (e) {
    e.preventDefault();
    $('#customer-formdata').addClass('d-none');
    $('#showroom-page').removeClass('d-none');
    $('html, body').animate({
        scrollTop: $('#showroom-page').offset().top
    }, 500);
});

$('body').on('click', '#confirmation-bookking', function (e) {
    e.preventDefault();
    var appointmentID = $('#appointmentID').val();
    var submitUrl = $(this).data('url');
    $.spinner().start();
    $.ajax({
        url: submitUrl,
        type: 'get',
        data: { appointmentID: appointmentID },
        success: function (response) {
            $('#customerDetails-page').addClass('d-none');
            $('#confirmation-page').removeClass('d-none');
            $('.pd-hero-banner, .service-image-banner, .astralcomponent-container, .testimonial-section').addClass('d-none');
            $('.storepage .service-image-banner:last').removeClass('d-none');
            $('.divider-image.text-center').removeClass('d-none');
            $('#confirmation-page').html(response);
            $.spinner().stop();
            $('html, body').animate({
                scrollTop: $('#confirmation-page').offset().top
            }, 500);
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification($errorMessage);
        }
    });
});

$('body').on('input blur', '#jewelry-formdata input', function () {
    var $field = $(this);
    var value = $field.val();
    value = value.replace(/^\s+/, '');
    value = value.replace(/\s{2,}/g, ' ');
    if ($field.attr('type') === 'email') {
        value = value.replace(/\s+/g, '');
    }
    $field.val(value);
});

$('body').on('change input blur', '#jewelry-formdata input', function () {
    validateUtils.validateField($(this));
    if ($(this).hasClass('firstname-input')) {
        var $customDropdown = $('.firstname-input-field').find('.custom-drop-down');
        if ($(this).hasClass('is-invalid')) {
            $customDropdown.addClass('error-valid');
        } else {
            $customDropdown.removeClass('error-valid');
        }
    }
    if ($(this).hasClass('phone-input')) {
        var $phoneDropdown = $('.phone-input-field').find('.custom-drop-down');
        if ($(this).hasClass('is-invalid')) {
            $phoneDropdown.addClass('error-valid');
        } else {
            $phoneDropdown.removeClass('error-valid');
        }
    }
});

$('body').on('click', '.form-firstname-dropdown .custom-option-value', function () {
    var $this = $(this);
    var titleCode = $this.data('title');
    var titleText = $this.text().trim();
    $this.siblings().removeClass('selected');
    $this.addClass('selected');
    $this.closest('.custom-drop-down-section').find('.selected-value').text(titleText);
    $('#catalogueTitle').val(titleCode);
});

$('body').on('click', '#ckc-jewelry-appointment-date', function (e) {
    e.preventDefault();
    var $dateInput = $('#ckc-jewelry-appointment-date');
    if ($dateInput.length && $dateInput.data('datepicker')) {
        validateUtils.initializeEarPiercingDatepicker();
    }
    $dateInput.datepicker('show');
});

$('body').on('input', '#languagepreference', function () {
    var value = $(this).val();
    value = value.replace(/[^a-zA-Z]/g, '');
    $(this).val(value);
});

$('body').on('change input blur', '#ckc-jewelry-appointment-date', function () {
    $('.invalid-feedback .noslots-available').addClass('d-none');
    var selectedDate = $(this).val();
    var $slotdropdown = $('#slot-dropdown-section .slot-dropdown');
    var $slotdiv = $('.time-slot-select .custom-drop-down-section');

    if (selectedDate) {
        $slotdropdown.removeClass('disabledstate');
        $slotdiv.removeClass('slot-dropdown-section');
    } else {
        $slotdropdown.addClass('disabledstate');
        $slotdiv.addClass('slot-dropdown-section');
    }
});

$(document).on('click', '#astraltimeslotplaced li', function () {
    $('#slot-dropdown-section').removeClass('is-invalid');
});
